import { includes, get, toLower, map } from 'lodash';
import classNames from 'classnames';
import React, { Component, PropTypes } from 'react';
import { bylineToString, getLocalLink } from 'utils/NewsUtils';
import { filterItems } from 'utils/CategoryUtils';
import ComponentTitle from 'components/shared/ComponentTitle';
import ReadMoreButton from 'components/shared/ReadMoreButton';
import Timestamp from 'components/Timestamp';
import Image from 'components/Image';
import { buildURLFingerprinting } from '../../../shared/utils/UrlUtils';
import { showWindow, getDataOfWindowOpen } from 'utils/WindowUtils';
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';


const HERO_SLIDER_TYPE = 'hero';

class SliderArticleList extends Component {
  static propTypes = {
    FRN_rawResponses: PropTypes.array,
    title: PropTypes.string,
    titleColor: PropTypes.string,
    textColor: PropTypes.string,
    startArticleIndex: PropTypes.number,
    types: PropTypes.array,
    displaySizes: PropTypes.array,
    showTitle: PropTypes.bool,
    numberOfItems: PropTypes.number,
    layout: PropTypes.string,
    showHeroByline: PropTypes.bool,
    showListByline: PropTypes.bool,
    heroTextColor: PropTypes.string,
    heroBackgroundColor: PropTypes.string,
    maintainHeroImageAspectRatio: PropTypes.bool,
    heroImageBackgroundColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    showTimestamp: PropTypes.bool,
    showUpdatedDate: PropTypes.bool,
    timestampOptions: PropTypes.shape({
      showElapsedTime: PropTypes.bool,
      displayShortDateTime: PropTypes.bool
    }),
    showArrows: PropTypes.bool,
    showMoreArrow: PropTypes.bool,
    categoryUrl: PropTypes.string,
    showReadMore: PropTypes.bool,
    readMoreText: PropTypes.string,
    readMoreBackgroundColor: PropTypes.string,
    readMoreTextColor: PropTypes.string,
    videoIconPlacement: PropTypes.string,
    titleType: PropTypes.string,
    // only for VideoPlayer
    onPlayVideo: PropTypes.func,
    currentIndexVideo: PropTypes.number
  };

  static defaultProps = {
    startArticleIndex: 0,
    numberOfItems: 7,
    heroTextColor: "#FFFFFF",
    heroBackgroundColor: "#333333",
    maintainHeroImageAspectRatio: false,
    heroImageBackgroundColor: '#FFF',
    showReadMore: false,
    showMoreArrow: true,
    videoIconPlacement: 'center',
    showUpdatedDate: false,
    titleType: TITLE_TYPE.MODULE_TITLE,
    types: ['story', 'clip', 'link']
  };

  constructor(props) {
    super(props);
    this.sliderItemContainer = null;
  }

  _shiftLeft(numberOfItems, direction) {
    const $ = window['$'];
    const $sliderContainer = $(this.sliderItemContainer);
    const sliderContainerLeftPos = $sliderContainer.scrollLeft();
    const sliderContainerWidth = $sliderContainer[0].scrollWidth;
    const newLeftPos = direction === 'left' ?
      sliderContainerLeftPos - (sliderContainerWidth / numberOfItems) :
      sliderContainerLeftPos + (sliderContainerWidth / numberOfItems);

    $sliderContainer.animate({scrollLeft: newLeftPos}, '250');
  }

  _onPlayVideo(e, index) {
    const { onPlayVideo } = this.props;
    if (onPlayVideo) {
      e.preventDefault();
      onPlayVideo(index);
    }
  }

  render() {
    const location = typeof window !== 'undefined' ? window.location : undefined;
    const {
      FRN_rawResponses: [
        {
          data: {
            features: items = [],
            headline = ''
          } = {}
        } = {}
      ] = [],
      showHeroByline = true,
      showListByline = true,
      showUpdatedDate,
      title,
      titleColor,
      showTitle = true,
      textColor,
      numberOfItems,
      startArticleIndex,
      types,
      displaySizes = [],
      layout,
      heroTextColor,
      heroBackgroundColor,
      maintainHeroImageAspectRatio,
      heroImageBackgroundColor,
      backgroundColor,
      timestampOptions: {
        showElapsedTime,
        displayShortDateTime
      } = {},
      showReadMore,
      readMoreText,
      readMoreBackgroundColor,
      readMoreTextColor,
      showArrows = true,
      showMoreArrow,
      categoryUrl,
      videoIconPlacement,
      titleType,
      currentIndexVideo
    } = this.props;

    const offset = Math.max(startArticleIndex, 0);
    const filteredItems = filterItems(items, { type: types, displaysize: displaySizes }); 
    const itemsToShow = filteredItems.slice(offset, numberOfItems + offset);

    if (!itemsToShow.length) {
      return null;
    }

    const componentTitle = title || headline;
    let heroComponent;

    if (layout === HERO_SLIDER_TYPE) {
      const {
        id = '',
        url = '',
        type = '',
        link = '',
        updatedDate = '',
        publishedDate = '',
        layout: layoutFeed = '',
        abstract: previewText = '',
        headline: smallHeadline = '',
        bylines = [],
        seo: { pageurl: slug = ''} = {},
        surfaceable: [ { type: featureType = '' } = {} ] = [],
        abstractimage: {
          filename: image = '',
          lastEditedDate = ''
        } = {},
        images = {},
        window: {
          isnewwindow = false,
          height = '500',
          width = '500',
          showtoolbar = true,
          showscrollbar = true,
          showlocation = true,
          isresizable = true
        } = {},
        options: {
          date: {
            published: {
              showonabstract: showPublished = true
            } = {},
            updated: {
              showonabstract: showUpdated = true
            } = {}
          } = {}
        } = {}
      } = itemsToShow[0];

      const linkImage = get(images, 'abstract.filename', '');
      const isVideoAttached = type.toLowerCase() === 'clip' || featureType.toLowerCase() === 'clip';
      const imageHeroThumbnailClassName = classNames(
        'SliderArticleList-heroThumbnail',
        { [`VideoThumbnail VideoThumbnail-${videoIconPlacement}`]: isVideoAttached }
      );

      let customBackgroundStyles = {};

      let scaledImage = (linkImage || image) ? buildURLFingerprinting({url: (linkImage || image) + '?auto=webp&disable=upscale&width=1410', lastEditedDate, queryStr: '&'}) : null; // use the same src for background as img tag
      customBackgroundStyles['backgroundImage'] = 'url(' + scaledImage + ')';
      customBackgroundStyles['backgroundColor'] = heroImageBackgroundColor;

      if (maintainHeroImageAspectRatio) {
        customBackgroundStyles['backgroundSize'] = 'contain';
      } else {
        customBackgroundStyles['backgroundSize'] = 'cover';
      }

      let timestamp;

      const iframeImage = get(images, 'graphic.filename', '');
      const isShowWindowLayout = isnewwindow && (type === 'link');
      const urlIFrameOrUrlLoc = layoutFeed === 3 ? (url || iframeImage) : link;
      const dataOfWindowOpen = getDataOfWindowOpen(width, height, showtoolbar, showscrollbar, showlocation, isresizable);
      const classNameSliderArticleList = classNames(
        'SliderArticleList-heroContainer',
        {'SliderArticleList-hoverSliderArticleList': isShowWindowLayout}
      );

      if (showHeroByline) {
        const publishedDateTimestamp = showPublished ? publishedDate : null;
        const updatedDateTimestamp = showUpdated ? updatedDate : null;

        const timestampDate = showUpdatedDate ? updatedDateTimestamp : publishedDateTimestamp;
        timestamp = (
          <div className="SliderArticleList-heroText--textByline">
            <Timestamp publishDate={timestampDate} authors={ map(bylines, bylineToString)} showElapsedTime={showElapsedTime} displayShortDateTime={displayShortDateTime} />
          </div>
        );
      }

      heroComponent = (
        <div onClick={() => isShowWindowLayout && showWindow(urlIFrameOrUrlLoc, '_blank', dataOfWindowOpen)} className={classNameSliderArticleList} style={{color: textColor}}>
          <div className="SliderArticleList-heroText" style={{backgroundColor: heroBackgroundColor, color: heroTextColor}}>
            <a href={ !isShowWindowLayout ? getLocalLink(location, {id, type, slug, urlIFrameOrUrlLoc}) : null} className="SliderArticleList-heroLink">
              <h1 className="SliderArticleList-heroLinkTitle" >
                {smallHeadline}
              </h1>
            </a>
            <p className="SliderArticleList-heroText--abstract" dangerouslySetInnerHTML={{ __html: previewText}}/>
            {timestamp}
          </div>
          { (linkImage || image) ? <a href={ !isShowWindowLayout ? getLocalLink(location, {id, type, slug, urlIFrameOrUrlLoc}) : null} className={imageHeroThumbnailClassName} style={customBackgroundStyles}>
            {/* The following image tag is here for accessibility purposes */}
            <Image src={ scaledImage } enableImgOpt={false} alt={smallHeadline} imageClassNames={"Hero-image--accessible"} />
          </a> : null}
        </div>);

      itemsToShow.shift();
    }

    return (
      <div className="SliderArticleList">
        { showTitle && componentTitle ? <ComponentTitle titleType={titleType} showArrow={showMoreArrow} color={titleColor} title={componentTitle} link={categoryUrl ? categoryUrl : undefined} /> : null }
        { heroComponent }

        { showArrows ?
          <div className="SliderArticleList-scrollButton SliderArticleList-scrollButton--left"
               onClick={this._shiftLeft.bind(this, itemsToShow.length, 'left')}
               style={{backgroundColor}}/> : null }

        { showArrows ?
          <div className="SliderArticleList-scrollButton SliderArticleList-scrollButton--right"
               onClick={this._shiftLeft.bind(this, itemsToShow.length, 'right')}
               style={{backgroundColor}} /> : null }

        <div className="SliderArticleList-sliderItemsContainer"
             style={{backgroundColor}}
             ref={(container) => this.sliderItemContainer = container}
        >
            <div className="SliderArticleList-sliderItems">
              { itemsToShow.map((item, index) => {
                const {
                  id = '',
                  url = '',
                  type = '',
                  link = '',
                  updatedDate = '',
                  publishedDate = '',
                  layout: layoutFeed = '',
                  headline: smallHeadline = '',
                  bylines = [],
                  seo: { pageurl: slug = ''} = {},
                  surfaceable: [ { type: featureType = '' } = {} ] = [],
                  abstractimage: {
                    filename: image = '',
                    lastEditedDate = ''
                  } = {},
                  images = {},
                  options: {
                    date: {
                      published: {
                        showonabstract: showPublished = true
                      } = {},
                      updated: {
                        showonabstract: showUpdated = true
                      } = {}
                    } = {}
                  } = {},
                  window: {
                    isnewwindow = false,
                    height = '500',
                    width = '500',
                    showtoolbar = true,
                    showscrollbar = true,
                    showlocation = true,
                    isresizable = true
                  } = {}
                } = item;
                const isVideoAttached = type.toLowerCase() === 'clip' || featureType.toLowerCase() === 'clip';
                const imageThumbnailClassName = classNames(
                  'SliderArticleList-sliderItemThumbnail',
                  { [`VideoThumbnail VideoThumbnail-${videoIconPlacement}`]: isVideoAttached },
                  {['SliderArticleList-sliderItemThumbnail--active']: index === currentIndexVideo}
                );

                const dataOfWindowOpen = getDataOfWindowOpen(width, height, showtoolbar, showscrollbar, showlocation, isresizable);

                const iframeImage = get(images, 'graphic.filename', '');
                const linkImage = get(images, 'abstract.filename', '');

                const isShowWindowLayout = isnewwindow && (type === 'link');
                const urlIFrameOrUrlLoc = layoutFeed === 3 ? (url || iframeImage) : link;

                const classNameSliderArticleList = classNames(
                  'SliderArticleList-sliderItem',
                  {'SliderArticleList-hoverSliderArticleList': isShowWindowLayout}
                );

                const isOnClick = () => {isShowWindowLayout && showWindow(urlIFrameOrUrlLoc, '_blank', dataOfWindowOpen);};

                let timestamp;
                const backgroundImage = (linkImage || image) ? `url('${buildURLFingerprinting({url: (linkImage || image) + '?auto=webp&disable=upscale&height=134', lastEditedDate, queryStr: '&'})}')` : null;

                if (showListByline) {
                  const publishedDateTimestamp = showPublished ? publishedDate : null;
                  const updatedDateTimestamp = showUpdated ? updatedDate : null;

                  const timestampDate = showUpdatedDate ? updatedDateTimestamp : publishedDateTimestamp;
                  timestamp = <Timestamp publishDate={timestampDate} authors={ map(bylines, bylineToString)} showElapsedTime={showElapsedTime} displayShortDateTime={displayShortDateTime} />;
                }

                const href = !isShowWindowLayout ? getLocalLink(location, {id, type, slug, urlIFrameOrUrlLoc}) : null;

                return (
                  <div onClick={isOnClick} className={classNameSliderArticleList} key={index} ref={index === 0 ? 'firstItem' : null}>
                    <a href={href} onClick={(e) => this._onPlayVideo(e, index)}>
                      <div className={imageThumbnailClassName} style={{backgroundImage}} />
                    </a>
                    <div className="SliderArticleList-sliderItemTextContainer" style={{color: textColor}}>
                      <div className="SliderArticleList-sliderItemText">
                        <a href={href} onClick={(e) => this._onPlayVideo(e, index)}>
                          <h1 className="SliderArticleList-sliderItemHeadline">
                            {smallHeadline}
                          </h1>
                        </a>
                        {timestamp}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
        </div>
        { showReadMore ?
          <ReadMoreButton
            link={categoryUrl}
            textColor={readMoreTextColor}
            text={readMoreText}
            backgroundColor={readMoreBackgroundColor} /> : null}
      </div>
    );
  }
}

export default SliderArticleList;



// WEBPACK FOOTER //
// ./app/components/news/SliderArticleList.js